export const translation = {
    dialog: {
        title: 'Deployment History',
        loading: 'Retrieving deployment history…',
        columns: {
            version: 'Version',
            user: 'User',
            deployedAt: 'Deployed At ({{tz}})',
            deployedAs: 'Deployed As'
        }
    }
};
